module.exports = __webpack_public_path__ + "static/yifang-627a77180680c4cc22d0ed99a7cfb72b.png";